// extracted by css-extract-rspack-plugin
export default {"pendingComment":"ConversationItemBody-module__pendingComment__dtogp"};